import HttpService from '@/common/services/HttpService'

const casePath = `/api/v3/cases/`
const generateDescriptionPath = `/generate-description`

export const generateDescription = async (caseId: number): Promise<string> => {
  return HttpService.getData<string>(`${casePath}${caseId}${generateDescriptionPath}`)
}
